import React from "react";
import Body from "./Body";

const Others = () => {
  const _this = {};
  return <Body {..._this} />;
};

export default Others;
